<div style="margin: 0 auto">
  <app-loading-spinner></app-loading-spinner>
</div>
